import React, { useState } from 'react';
import { Box, TextField, Button } from '@mui/material';

function AddUserForm({ onAdd }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const validateEmail = (email) => {
    if (!email.trim()) {
      return 'Email is required';
    }
    if (!email.endsWith('@bluetab.net')) {
      return 'Only @bluetab.net email addresses are allowed';
    }
    return '';
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    setError(validateEmail(newEmail));
  };

  const handleSubmit = () => {
    const validationError = validateEmail(email);
    if (validationError) {
      setError(validationError);
      return;
    }
    
    onAdd(email.trim().toLowerCase());
    setEmail('');
    setError('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <Box display="flex" gap={2}>
      <TextField 
        label="Email (@bluetab.net only)"
        value={email}
        onChange={handleEmailChange}
        onKeyPress={handleKeyPress}
        variant="outlined"
        fullWidth
        error={!!error}
        helperText={error}
        placeholder="user@bluetab.net"
      />
      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleSubmit}
        disabled={!!error || !email.trim()}
      >
        Add User
      </Button>
    </Box>
  );
}

export default AddUserForm;
